export default function(h) {
  return h('audio', { attrs: { id: 'audio' } })
}
